import React from 'react';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';

export function Billing({
    billingLoading,
    handleManageBilling,
    statusInfo,
    planLabel,
    stripeData,
    sortedPlans,
    hasSeatPlan,
    seatsAllowed,
    hasActiveSub,
    handleSubscribe,
    checkoutLoading
}) {
    return (
        <section className="dash-stack">
            <article className="dash-card">
                <div className="card-head">
                    <div className="card-title-group">
                        <h4>Subscription Status</h4>
                        <span className="card-subtle">Check your current plan and renewal dates.</span>
                    </div>
                    <Button
                        variant="secondary"
                        onClick={handleManageBilling}
                        loading={billingLoading}
                    >
                        Manage Billing
                    </Button>
                </div>

                <div className="status-row" style={{ marginTop: '16px' }}>
                    <Badge variant={statusInfo?.text === 'Active' ? 'success' : 'neutral'}>
                        {statusInfo?.text || 'Not Active'}
                    </Badge>
                    <span className="status-text">{planLabel || 'No plan selected'}</span>
                    {stripeData?.currentPeriodEnd && (
                        <span className="status-text text-muted">
                            • {stripeData.cancelAtPeriodEnd ? 'Cancels' : 'Renews'} {new Date(stripeData.currentPeriodEnd * 1000).toLocaleDateString()}
                        </span>
                    )}
                </div>
            </article>

            <article className="dash-card">
                <div className="card-head" style={{ marginBottom: '20px' }}>
                    <div className="card-title-group">
                        <h4>Plans</h4>
                        <span className="card-subtle">Upgrade or switch to increase seat capacity.</span>
                    </div>
                </div>

                <div className="plan-grid">
                    {sortedPlans.map(([priceId, plan]) => {
                        const isCurrent = stripeData?.priceId === priceId;
                        const deltaSeats = hasSeatPlan ? plan.seats - seatsAllowed : plan.seats;
                        let ctaLabel = 'Start Plan';
                        if (isCurrent) ctaLabel = 'Current Plan';
                        else if (hasActiveSub && deltaSeats > 0) ctaLabel = `Add ${deltaSeats} Seats`;
                        else if (hasActiveSub && deltaSeats <= 0) ctaLabel = 'Switch Plan';

                        return (
                            <div className={`plan-card ${isCurrent ? 'plan-card--current' : ''}`} key={priceId}>
                                <div className="plan-card-header">
                                    <p className="plan-label">{plan.label}</p>
                                    {isCurrent && <Badge variant="blue">Current</Badge>}
                                </div>
                                <h5 className="plan-price">{plan.seats} seats</h5>
                                <Button
                                    variant={isCurrent ? 'secondary' : 'primary'}
                                    className="plan-btn"
                                    onClick={() => handleSubscribe(priceId)}
                                    disabled={isCurrent}
                                    loading={checkoutLoading === priceId}
                                >
                                    {ctaLabel}
                                </Button>
                            </div>
                        );
                    })}
                </div>
            </article>
        </section>
    );
}
